/**
 * Route for `custom-login-domain-for-publisher-portal`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomLoginDomainForPublisherPortalPage } from "../features/custom-login-domain-for-publisher-portal/CustomLoginDomainForPublisherPortalPage";

export const customLoginDomainForPublisherPortalRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-login-domain-for-publisher-portal",
	component: CustomLoginDomainForPublisherPortalPage,
});

export default customLoginDomainForPublisherPortalRoute;
